const countLabel = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;
/**
 * Signup length shown in the activation box.
 * Whole weeks are "N weeks" ("1 week" when singular).
 * A remainder is spelled out ("12 weeks 3 days", "1 day" when singular).
 * Under a week is days only.
 */
export const formatActivationLength = (days) => {
    if (!Number.isInteger(days) || days < 0) {
        return '';
    }
    const weeks = Math.floor(days / 7);
    const leftoverDays = days % 7;
    if (weeks === 0) {
        return countLabel(leftoverDays, 'day', 'days');
    }
    const weeksLabel = countLabel(weeks, 'week', 'weeks');
    if (leftoverDays === 0) {
        return weeksLabel;
    }
    return `${weeksLabel} ${countLabel(leftoverDays, 'day', 'days')}`;
};
